export const currencyExp = /\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g;
export const numericExp = /[+-]?([0-9]*[.])?[0-9]+/g;
